module.exports = __webpack_public_path__ + "static/assets/14ea6745b6f8a3c8e3cb4d3392f04573.svg";